import { dealwithNewOldData } from '@op/utils';

export function dealwithMetricsData(
  keyMetrics: any,
  sortKeyMetricsMap: { [key: string]: number },
  {
    key,
    value,
  }: {
    key: string;
    value: string;
  } = { key: 'key', value: 'value' },
) {
  let result: any = { key_metrics: [], time_period: {} };
  if (keyMetrics) {
    const keepKeyMetricsKeys = Object.keys(sortKeyMetricsMap || {});
    const { new_list, old_list, link_time: linkTime = {} } = keyMetrics || {};
    const newList = new_list
      ?.filter((item: any) => keepKeyMetricsKeys.includes(item[key]))
      ?.sort(
        (a: any, b: any) =>
          sortKeyMetricsMap[a[key]] - sortKeyMetricsMap[b[key]],
      );

    const key_metrics = dealwithNewOldData<{ key: string; value: number }>(
      newList,
      old_list,
      key,
      [value],
      (newItem: any, oldItem) => ({
        metric_name: newItem?.[key] || newItem.key,
        pre_value: oldItem?.value || 0,
      }),
      undefined,
      undefined,
      () => 'dod',
    );

    result = {
      key_metrics,
      time_period: {
        start_date: linkTime.new_start_date,
        end_date: linkTime.new_end_date,
        pre_start_date: linkTime.old_start_date,
        pre_end_date: linkTime.old_end_date,
      },
    };
  }

  return result;
}
